import React, { Component } from 'react';
import DataGrid from '../../components/datagrid/DataGrid';

const columns = [
  { id: 'agencyPlacementId', label: 'Agency Placement ID' },
  { id: 'agencyPlacementName', label: 'Agency Placement Name' },
  { id: 'billingGroup', label: 'Billing Group', numeric: true },
  { id: 'start', label: 'Start', numeric: false, date: 'MM/DD/YYYY' },
  { id: 'end', label: 'End', date: 'MM/DD/YYYY'}
];

class ClonePlacementGrid extends Component {

  getRows() {
    const { placementCopies } = this.props;
    return placementCopies.map(p => Object.assign({}, {
      agencyPlacementId: p.agencyPlacementId,
      agencyPlacementName: p.agencyPlacementName,
      billingGroup: p.billingGroup,
      start: p.start,
      end: p.end
    }));
  }


  render() {
    return(
      <DataGrid
        plain
        minWidth={1020}
        columns={columns}
        data={this.getRows()}
        title="New Copies"
        showFilterRow={false}
      />
    )
  }
}


export default ClonePlacementGrid;

